import { Tab, Tabs } from '@mui/material'
import { styled } from '@mui/material/styles'

export const KTabs = styled(Tabs)(({ theme }) => ({
  '& .MuiTabs-indicator': {
    height: 4,
    backgroundColor: theme.palette.success.main,
  },

  '& .MuiTabs-flexContainer': {
    borderBottom: `4px solid ${theme.palette.divider}`,
  },
}))

export const KTab = styled(Tab)(({ theme }) => ({
  ...theme.typography.h5,
  width: 160,
  '&.Mui-selected': {
    color: theme.palette.success.main,
  },
}))
